var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"missions bp-page"},[(_vm.show_page)?[_c('PageHeader'),_vm._v(" "),_c('div',{staticClass:"bp-page__content"},[_c('MissionsChallenge'),_vm._v(" "),_c('MissionsList')],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }